<template>
  <div id="LinesList">
    <table v-if="this.viewLoader && this.list && this.list.length">
      <thead v-if="!IsMobile">
        <tr>
          <th v-show="!IsMobile">{{ $t("crossConnects.ticket_esteso") }}</th>
          <th>{{ $t("crossConnects.tipologia") }}</th>
          <th>{{ $t("crossConnects.a_end_rack") }}</th>
          <th>{{ $t("crossConnects.a_end_unita") }}</th>
          <th>{{ $t("crossConnects.a_end_slot") }}</th>
          <th>{{ $t("crossConnects.a_end_fibre") }}</th>
          <th v-if="!IsMobile"></th>
          <th v-if="!IsMobile"></th>
          <th v-if="!IsMobile"></th>
          <th v-if="!IsMobile"></th>
        </tr>
      </thead>
      <tbody v-if="IsMobile">
        <MobileCard
          v-for="(item, keyItem) in paginatedList"
          :key="keyItem"
          :titles="[
            'ticket_esteso',
            'tipologia',
            'a_end_rack',
            'a_end_unita',
            'a_end_slot',
            'a_end_fibre'
          ]"
          :item="{
            ticket_esteso: item.ticket_esteso,
            tipologia: item.tipo,
            a_end_rack: item.aend_rack_name,
            a_end_unita: item.aend_unita,
            a_end_slot: item.aend_slot,
            a_end_fibre: item.aend_fibre
          }"
          translationPath="crossConnects"
        >
          <template #url-label>
            <router-link
              :to="
                '/' +
                (this.$i18n.locale === 'it'
                  ? 'cross-connects-attive/dettaglio/'
                  : 'active-cross-connects/detail/') +
                (item.xcon_id || item.id)
              "
            >
              <div class="cdlButton">
                <span>
                  {{ $t("crossConnects.details") }}
                </span>
              </div>
            </router-link>
          </template>
        </MobileCard>
      </tbody>
      <tbody v-else-if="!IsMobile">
        <tr
          v-for="(item, keyItem) in paginatedList"
          :key="keyItem"
          :class="{ odd: keyItem % 2 }"
        >
          <td>
            <span>
              {{ item.ticket_esteso }}
            </span>
          </td>
          <td>
            <div>{{ item.tipo }}</div>
          </td>
          <td>
            <div>{{ item.aend_rack_name || "-" }}</div>
          </td>
          <td>
            <div>{{ item.aend_unita || "-" }}</div>
          </td>
          <td>
            <div>{{ item.aend_slot || "-" }}</div>
          </td>
          <td>
            <div>{{ item.aend_fibre || "-" }}</div>
          </td>

          <td></td>
          <td>
            <router-link
              :to="
                '/' +
                (this.$i18n.locale === 'it'
                  ? 'cross-connects-attive/dettaglio/'
                  : 'active-cross-connects/detail/') +
                (item.xcon_id || item.id)
              "
            >
              <div class="cdlButton">{{ $t("crossConnects.details") }}</div>
            </router-link>
          </td>
          <td colspan="3">
            <div style="display: flex">
              <HelpRequestBtn
                v-if="ctrlPerms(['incident_lista'])"
                :component-name="'CrossConnectIncidentForm'"
                :asset-type="'cross-connects'"
                :item-id="item.xcon_id || item.id"
                :icon="'warning'"
                :label="$t('help.incident.formTitle')"
              />

              <HelpRequestBtn
                v-if="ctrlPerms(['change_request_list'])"
                :component-name="'CrossConnectChangeRequestForm'"
                :asset-type="'cross-connects'"
                :item-id="item.xcon_id || item.id"
                :icon="'person'"
                :label="$t('help.changeRequest.formTitle')"
              />
            </div>
          </td>
        </tr>
      </tbody>
      <tbody v-else-if="this.viewLoader">
        <tr>
          <td colspan="7" style="text-align: center">
            <span>{{ $t("crossConnects.TBD") }}</span>
          </td>
        </tr>
      </tbody>
    </table>
    <div>
      <br /><br />
      <MyError :viewError="viewError" :message="$t('tickets.error')" />
    </div>
    <paginator
      v-if="totalPage > 1"
      :total-page="totalPage"
      :current-page="currentPage"
      @change-page="this.changePage"
      @prev-page="this.prevPage"
      @next-page="this.nextPage"
    ></paginator>
  </div>
</template>

<script>
import MyError from "@/components/MyError.vue";
import Paginator from "@/components/Paginator.vue";
import HelpRequestBtn from "@/components/Tables/HelpRequestBtn";
import MobileCard from "@/components/Cards/MobileCard.vue";
import "@/assets/scss/Solutions.scss";

export default {
  name: "CrossConnectList",
  components: {
    MyError,
    Paginator,
    HelpRequestBtn,
    MobileCard,
  },
  props: {
    list: Array,
    viewLoader: Boolean,
    viewError: Boolean,
  },
  data() {
    return {
      pageSize: 10,
      currentPage: 1,
      messageError: "",
      IsMobile: this.$IsMobile(),
    };
  },
  methods: {
    changePage(page) {
      this.currentPage = page;
    },
    nextPage() {
      if (this.currentPage == this.totalPage) {
        return;
      }
      this.currentPage = parseInt(this.currentPage) + 1;
    },
    prevPage() {
      if (this.currentPage == 1) {
        return;
      }
      this.currentPage = parseInt(this.currentPage) - 1;
    },
    viewDetails(id) {
      const locale = this.$i18n.locale;
      if (locale === "it") {
        this.$router.push(`/cross-connects-attive/dettaglio/${id}`);
      } else {
        this.$router.push(`/active-cross-connects/detail/${id}`);
      }
    },
    ctrlPerms(perms) {
      return this.$ctrlPermissions(perms);
    },
  },
  computed: {
    totalPage() {
      return Math.ceil(this.list.length / this.pageSize) > 1
        ? Math.ceil(this.list.length / this.pageSize)
        : 1;
    },
    paginatedList() {
      const start = (this.currentPage - 1) * this.pageSize;
      const end = start + this.pageSize;
      return this.list.slice(start, end);
    },
  },
};
</script>
